import {
    FACETED_CATEGORY_TAB_OPEN,
    FACETED_FILTER_TAB_OPEN,
    FACETED_SEARCH_RECEIVE,
    FACETED_SEARCH_TOGGLE_COMPACT,
    FACETED_SEARCH_TOGGLE_VALUE,
} from '../constants';

const defaultState = {
    subNavigation: null,
    sortCriteria: null,
    facetFilters: [],
    visibleDropdownMenu: [],
    navigationTheme: 'filter',
    productsViewCachedId: null,
    filterTabOpen: false,
    categoryTabOpen: false,
};

export const facetedSearch = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FACETED_SEARCH_RECEIVE:
            return {
                ...state,
                ...payload,
            };
        case FACETED_SEARCH_TOGGLE_VALUE:
            return {
                ...state,
                facetFilters: payload.facetFilters,
            };
        case FACETED_SEARCH_TOGGLE_COMPACT: {
            const { visibleDropdownMenu } = payload;
            return {
                ...state,
                visibleDropdownMenu: state.visibleDropdownMenu.includes(
                    visibleDropdownMenu
                )
                    ? []
                    : [visibleDropdownMenu],
            };
        };
        case FACETED_FILTER_TAB_OPEN:
            return {
                ...state,
                ...payload,
            };
        case FACETED_CATEGORY_TAB_OPEN:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
